// Environment detection + kill-switch.
// Runs only in browser; SSR guard returns 'ssr'.

export type AppEnv = "ssr" | "killed" | "local" | "preview" | "production";

declare global {
  interface Window {
    __ANALYTICS_KILL__?: boolean;
    ANALYTICS_DEBUG?: boolean;
  }
}

export const APP_ENV: AppEnv = (() => {
  if (typeof window === "undefined") return "ssr";
  if (window.__ANALYTICS_KILL__ === true) return "killed";
  const h = window.location.hostname;
  if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".local")) return "local";
  if (h === "nickrobotic.com" || h === "www.nickrobotic.com") return "production";
  // Lovable preview hosts: id-preview--*.lovable.app, *.lovableproject.com
  return "preview";
})();

export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ||
  (import.meta.env.MODE as string | undefined) ||
  "unknown";

export const isBrowser = (): boolean => typeof window !== "undefined";

export const isDebugEnabled = (): boolean =>
  isBrowser() && (APP_ENV === "local" || APP_ENV === "preview") && window.ANALYTICS_DEBUG === true;

export const isLive = (): boolean => APP_ENV !== "ssr" && APP_ENV !== "killed";
